import { render, staticRenderFns } from "./FitGapTaskItem.vue?vue&type=template&id=4eef8d58&scoped=true"
import script from "./FitGapTaskItem.vue?vue&type=script&lang=js"
export * from "./FitGapTaskItem.vue?vue&type=script&lang=js"
import style0 from "./FitGapTaskItem.vue?vue&type=style&index=0&id=4eef8d58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef8d58",
  null
  
)

export default component.exports